/** API local / desarrollo — `npm run start` usa este archivo */
const apiUrl = 'https://apidev-lette.neuroneats.com';

export const environment = {
  domainId: 76,
  domainName: 'Lette Helados',
  PORT: 4076,
  production: false,
  webSiteUrl: 'http://localhost:4200',
  url: apiUrl,
  uriBanner: `${apiUrl}/file/banner/`,
  uriProduct: `${apiUrl}/file/product/`,
  uriCatalogue: `${apiUrl}/file/catalogue/`,
  uriImg: `${apiUrl}/file/parameter/`,
  captchaKey: '6LcCwQIrAAAAAMkQUNYckmwQb0hZMPp_CINhfzPH',
  bg_general: 'https://centinelapistag.cardinalcommerce.com',
  PWA: true,
  defaultImg: './assets/admin/defaultImage.png',
  vippo: {
    receivingInstrument: '01020129290000428857',
    receivingBankName: 'Banco de Venezuela',
    production: false,
  },
  whatsapp:
    'https://api.whatsapp.com/send?phone=17867185949?&text=Hola podrias darme información.',
  stripePublishKey:
    'pk_live_51PO8bHGVPLDmRlydTjFW5emy5EeXCJaP529TmrPJhcCeU6b97bsSQsJrYjzRNqTaJoAXgTaePDIGxvWkbPiSJnPC00btzklG6d',
  ckConfig:
    'dialogui,dialog,a11yhelp,about,basicstyles,bidi,blockquote,clipboard,embedbase,' +
    'button,panelbutton,panel,floatpanel,colorbutton,colordialog,menu,' +
    'contextmenu,dialogadvtab,div,elementspath,enterkey,entities,popup,' +
    'filebrowser,find,fakeobjects,floatingspace,listblock,richcombo,' +
    'font,format,forms,horizontalrule,htmlwriter,iframe,indent,' +
    'indentblock,indentlist,justify,link,list,liststyle,magicline,' +
    'newpage,pagebreak,pastefromword,pastetext,preview,print,' +
    'removeformat,resize,save,menubutton,scayt,selectall,showblocks,' +
    'showborders,smiley,sourcearea,specialchar,stylescombo,tab,table,' +
    'tabletools,templates,toolbar,undo,wysiwygarea',
  firebaseConfig: {
    apiKey: 'AIzaSyBUqBWZ6zhp3ge0MdD902QMWFp698VZ6dA',
    authDomain: 'neuron-web-online.firebaseapp.com',
    projectId: 'neuron-web-online',
    storageBucket: 'neuron-web-online.appspot.com',
    messagingSenderId: '559396221040',
    appId: '1:559396221040:web:d3ec9cd55d6ce43bc9c4b5',
    measurementId: 'G-C8FR37Q2JX',
    vapidKey:
      'BHpxAlAxuZ-_7WEmnTnYLhNNIFaehrYi-nD5mTZa1UYkeHdyC_ynxQ9ySOOR4PZfuFM-pz1NFOh9cTn-aHiMIac',
  },
};
